import { OP } from "../../constant";

/**--------- list logs ------------ */
export function listLogsRequest(token, data) {
  return {
    type: OP.LIST_LOGS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function listLogsReset() {
  return {
    type: OP.LIST_LOGS_RESET,
  };
}

/**--------- list folder logs ------------ */
export function listFolderLogsRequest(token, data) {
  return {
    type: OP.LIST_FOLDER_LOGS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function listFolderLogsReset() {
  return {
    type: OP.LIST_FOLDER_LOGS_RESET,
  };
}

/**--------- view log ------------ */
export function viewLogRequest(token, data) {
  return {
    type: OP.VIEW_LOG_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewLogReset() {
  return {
    type: OP.VIEW_LOG_RESET,
  };
}
